import enableCustomConfigBranding from '../utils/enableCustomConfigBranding';
import enableRuntimeBranding from '../utils/enableRuntimeBranding';
import myTheme from './myTheme';
var findTheme = function (defaultTheme, brandingObj, runtimeBranding, clientappCustomBranding) {
    var placeholderBrandingObj = {
        bodyText: '#333333',
        bodylink: '#34657f',
        fieldFocus: '#3e8529',
        primaryBtnText: '#FFFFFF',
        primaryBtnHover: '#3e8529',
        primaryBtnBackground: '#3e8529',
        secondaryBtnText: '#34657F',
        secondaryBtnHover: '#FFFFFF',
        footerBackground: '#FFFFFF',
        footerText: '#000'
    };
    var enableBranding = function () {
        return {
            link: placeholderBrandingObj.bodylink,
            body: {
                text: placeholderBrandingObj.bodyText
            },
            field: {
                focus: placeholderBrandingObj.fieldFocus
            },
            button: {
                primary: {
                    text: placeholderBrandingObj.primaryBtnText,
                    hover: placeholderBrandingObj.primaryBtnHover
                },
                secondary: {
                    hover: placeholderBrandingObj.secondaryBtnHover
                },
                text: placeholderBrandingObj.secondaryBtnText,
                background: placeholderBrandingObj.primaryBtnBackground
            },
            footer: {
                background: placeholderBrandingObj.footerBackground,
                text: placeholderBrandingObj.footerText
            }
        };
    };
    if (defaultTheme) {
        return myTheme;
    }
    var myCustomTheme;
    if ((brandingObj && Object.keys(runtimeBranding).length !== 0) || null) {
        enableRuntimeBranding(brandingObj, runtimeBranding);
        myCustomTheme = enableBranding();
    }
    if ((clientappCustomBranding && brandingObj != null) || {}) {
        myCustomTheme = enableCustomConfigBranding(brandingObj, clientappCustomBranding, myCustomTheme);
    }
    return myCustomTheme;
};
export default findTheme;
